import type {DiscordHasRoleTriggerStruct} from '@cohort/shared/apps/discord/triggers/hasRole';
import {DiscordHasRoleTriggerIntegrationSpec} from '@cohort/shared/apps/discord/triggers/hasRole';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';

export const DiscordHasRoleTriggerIntegration: TriggerIntegration<DiscordHasRoleTriggerStruct> = {
  type: 'verification',
  spec: DiscordHasRoleTriggerIntegrationSpec,
};
